import { render, staticRenderFns } from "./PressReleaseInfo.vue?vue&type=template&id=39f58018&scoped=true"
import script from "./PressReleaseInfo.vue?vue&type=script&lang=js"
export * from "./PressReleaseInfo.vue?vue&type=script&lang=js"
import style0 from "./PressReleaseInfo.vue?vue&type=style&index=0&id=39f58018&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f58018",
  null
  
)

export default component.exports